import { render, staticRenderFns } from "./StepExibicao.vue?vue&type=template&id=2448eddc&scoped=true"
import script from "./StepExibicao.vue?vue&type=script&lang=js"
export * from "./StepExibicao.vue?vue&type=script&lang=js"
import style0 from "./StepExibicao.vue?vue&type=style&index=0&id=2448eddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448eddc",
  null
  
)

export default component.exports